import PropTypes from 'prop-types';
import { Grid, Stack } from '@mui/material';
import ProfileAbout from './ProfileAbout';
import ProfileFollowInfo from './ProfileFollowInfo';
import ProfileDepositHistory from './ProfileDepositHistory';

// ----------------------------------------------------------------------

Profile.propTypes = {
  info: PropTypes.object,
};

export default function Profile({ info }) {
  return (
    <Grid container spacing={3}>
      {/* 🔹 Left Side */}
      <Grid item xs={12} md={4}>
        <Stack spacing={3}>
          <ProfileFollowInfo
            follower={info.totalDeposit || 0}
            following={info.createdAt || 0}
          />

          <ProfileAbout
            name={info.fullName}
            nik={info.nik}
            phone={info.phone}
            address={info.address}
            email={info.email}
            role={info.role}
            site={info.site}
            totalDeposit={info.totalDeposit}
            totalSalary={info.totalSalary}
            isFraud={info.isFraud}
            isActive={info.isActive}
            updatedAt={info.updatedAt}
          />
        </Stack>
      </Grid>

      {/* 🔹 Right Side */}
      <Grid item xs={12} md={8}>
        <Stack spacing={3}>
          <ProfileDepositHistory userId={info.id} />
        </Stack>
      </Grid>
    </Grid>
  );
}
